import * as React from 'react';
import * as request from 'superagent';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import {Theme} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import {Typography} from '@mui/material';
import {APIError} from '~common/lib/types';
import URLManager from '~common/lib/url-manager';
import classNames from 'classnames';
import Renderers from '~common/lib/renderers';

const styles = (theme: Theme): StyleRules => ({


  cardContent: {
    margin: '10px 15px 10px 15px',
    height: 'calc(100% - 70px)'
  },
  countContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 120,
    fontSize: '3.0rem',
    width: '100%',
    height: '100%',
    cursor: 'pointer'
  },
  contentContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // minHeight: 120,
    // fontSize: '3.0rem',
    width: '100%',
    height: '100%',
    // cursor: 'pointer'
  },

});

interface Props {
  id: number;
  renderers: any;
  element: any;

  chromeless?: boolean;

  elementType: any;

  inEditMode?: boolean;

}

type State = {
  status: 'loading' | 'ready';
  data: any;
  error?: any;
};

class CountRenderer extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'loading',
      data: null
    };
  }

  UNSAFE_componentWillReceiveProps(
    newProps: Props & WithStyles<keyof typeof styles>
  ) {}

 componentDidMount() {
    const self = this;
    if (!this.props.element || !this.props.element.id) {
      console.error("No ID found on Props")
    } else {
   
    request
      .get('/api/dashboards/' + this.props.element.id)
      .set('accept', 'application/json')
      .send()
      .then((response) => {
        self.setState({status: 'ready', data: response.body});
      })
      .catch((err) => {
        if (err.response && err.response.text) {
          const apiErr = new APIError();
          apiErr.type = 'http';
          apiErr.message = err.response.text;
          self.setState({status: 'ready', error: apiErr});
        }
      });
    }
  }

  static register = () => {
   
    if(!Renderers.find("CountElementRenderer")){
     
      Renderers.register("CountElementRenderer", withStyles(styles)(CountRenderer))
    }
  }

  onClick = () => {
    const {data} = this.state;
    if (
      data &&
      data.element.fulfillmentCriteria &&
      data.element.elementAttributes &&
      data.element.elementAttributes.targetURL
    ) {
      const reducedForm = this.reduceCriteria(data.element.fulfillmentCriteria);

      var url: string = data.element.elementAttributes.targetURL;
      var crit = data.element.fulfillmentCriteria;
      delete crit.criteriaForm;
      delete crit.resultsForm;
      url += '?q=' + URLManager.getQueryStringValue(crit);
      window.location.href = url;
    }
  };

  reduceCriteria = (crit: any) => {
   
    delete crit['criteriaForm'];
    delete crit['resultsForm'];
  };

  getThresholdAttributes = (): any => {
    const {data} = this.state;

    let attr = {};
   

    if (
      data.element.elementAttributes &&
      data.element.elementAttributes.thresholds
    ) {
      const thresholds = data.element.elementAttributes.thresholds;
     

      if (thresholds.defaultAttributes) {
        attr = thresholds.defaultAttributes;
      }
      if (thresholds.entries) {
        var sorted = thresholds.entries.sort((a, b) => {
          return a.value > b.value;
        });

        for (let i of sorted) {
          if (i.floorValue <= data.content.count && i.attributes) {
            attr = i.attributes;
          }
        }
      }
    }

    return attr;
  };

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {chromeless, renderers} = this.props;
    const {status, data} = this.state;

    var cardContent: any = null;

    switch (status) {
      case 'loading':
        return (
          <div className={classes.container}>
            <LoadingView compact classes={{}} />
          </div>
        );

      default:
        if (data && data.element && data.element.elementType) {
          const styleAttributes = this.getThresholdAttributes();

          var renderer: any = null;
         
          cardContent = (
            <div
              onClick={this.onClick}
              className={classes.countContent}
              style={styleAttributes}>
              {data.content.count}
            </div>
          );
        }
    }


    return  <div className={classes.contentContainer}>{cardContent}</div>; 
    
  }
}

export default withStyles(styles)(CountRenderer);

